module.exports = __webpack_public_path__ + "img/infoicon.c1affee6.svg";